import { render, staticRenderFns } from "./insuranceInfo.vue?vue&type=template&id=8343757a"
import script from "./insuranceInfo.vue?vue&type=script&lang=js"
export * from "./insuranceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8343757a')) {
      api.createRecord('8343757a', component.options)
    } else {
      api.reload('8343757a', component.options)
    }
    module.hot.accept("./insuranceInfo.vue?vue&type=template&id=8343757a", function () {
      api.rerender('8343757a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/productManage/insuranceInfo.vue"
export default component.exports